// ============ START: Snap color image update ==============================
  document.addEventListener('DOMContentLoaded', function() {
    function updateSnapColourImages() {
      // Only run if snap colour option exists
      if (!document.querySelector('.template-product .form__selectors .snap-color-option-wrapper')) {
        return;
      }

      // Get all selected option values dynamically
      const snapSelectedOptions = [];
      document.querySelectorAll('.form__selectors [data-option-position]').forEach(selector => {
        const selected = selector.querySelector('input[type="radio"]:checked');
        snapSelectedOptions.push(selected ? selected.value : null);
      });

      // The last option is Snap Colour (index length-1)
      const snapOptionIndex = snapSelectedOptions.length - 1;
      const fixedOptions = snapSelectedOptions.slice(0, snapOptionIndex);

      // Loop over snap colour labels
      document.querySelectorAll(`.selector-wrapper[data-option-position="${snapOptionIndex + 1}"] .radio__fieldset label`).forEach(label => {
        const inputEl = label.closest('.radio__button')?.querySelector('input');
        const snapColour = inputEl ? inputEl.value : null;

        // Find matching variant
        const matchVariant = Array.from(document.querySelectorAll('.all-variants span')).find(variant => {
          const titleParts = variant.dataset.variantTitle.split(' / ').map(s => s.trim());
          return fixedOptions.every((val, idx) => titleParts[idx] === val) &&
                titleParts[snapOptionIndex] === snapColour;
        });

        if (matchVariant) {
          const imgEl = label.querySelector('img');
          if (imgEl && matchVariant.dataset.optionImage) {
            imgEl.src = matchVariant.dataset.optionImage;
            imgEl.style.display = '';
          }
        }
      });
    }

    // Run on load
    updateSnapColourImages();

    //Price update code on variant
    function updateVariantDetails(radio) {
      // Get currently selected hidden input value (variant ID)
      const variantId = document.querySelector('.product__form--buybutton input[name="id"]').value;
    
      // Find the matching variant span directly (no loop)
      const variantEl = document.querySelector('.all-variants .selected_variant[data-variant-id="' + variantId + '"]');

      if (variantEl) {
        const regularPrice = variantEl.getAttribute("data-variant-price");
        const comparePrice = variantEl.getAttribute("data-variant-compare-price");
        const savingPrice = variantEl.getAttribute("data-variant-saving-price");
        const savingPercentage = variantEl.getAttribute("data-variant-saving-percentage");

        // append updated price to the custom price
        var customPrice = document.querySelector(".product-wrap-custom");
        var customSavePrice = document.querySelectorAll(".product-section .product__price--savings");
        
        const priceContainer = customPrice.querySelector(".custom-product-regular-price");
        const regularPriceSpan = priceContainer.querySelector("span");
        const comparePriceContainer = customPrice.querySelector(".product__price--compare");
        console.log('regularPrice',regularPrice)
        console.log('comparePrice',comparePrice)
        // console.log('customSavePrice',customSavePrice.length)
        console.log('savingPrice',savingPrice)
        console.log('savingPercentage',savingPercentage)

        if (regularPriceSpan) {
          regularPriceSpan.innerText = regularPrice;
        } else {
          priceContainer.innerText = regularPrice;
        }
        if(comparePriceContainer){
          const comparePriceSpan = comparePriceContainer.querySelector("span");
          if (comparePriceSpan) {
            comparePriceSpan.innerText = comparePrice;
          } else {
            comparePriceContainer.innerText = comparePrice;
          }
        }else if(comparePriceContainer == null){
          let html = `<span class="money">${comparePrice}</span>`
          let comp = document.createElement('span');
          comp.classList.add('product__price--compare')
          comp.innerHTML = html;
          if(comparePrice) document.querySelector('span[data-product-price]').appendChild(comp);
        }

        if(!customSavePrice.length > 0){
          let comp = document.createElement('div');
          comp.classList.add('custom-save-prices')
          let html = `<span class="product__price--savings">
                <span class="product-saving-percentage">${savingPercentage}</span> Off - Save
                <span class="product-saving-amount">${savingPrice}</span>
              </span>`;

          let html1 = savingPrice != null ? html : '';

          let comp1 = document.querySelector('.product_review_block .custom-save-prices')
          if(comp1){
            comp1.innerHTML = html1
          }else{
            comp.innerHTML = html1;
            document.querySelector('.product-wrapper .product_review_block').appendChild(comp)
          } 
            
        }else{
          let comp = document.querySelector('.product_review_block .custom-save-prices')
          let html = `<span class="product__price--savings">
                <span class="product-saving-percentage">${savingPercentage}</span> Off - Save
                <span class="product-saving-amount">${savingPrice}</span>
              </span>`;

          comp.innerHTML = savingPrice != null ? html : '';
        }
        // if (customSavePrice.length > 0 && savingPrice != null) {
        //   customSavePrice.forEach(el => {
        //     el.style.visibility = "visible";
        //     // update percentage
        //     let percentageEl = el.querySelector(".product-saving-percentage");
        //     const percentageSpan = percentageEl.querySelector("span");
        //     if (percentageSpan) {
        //       percentageSpan.innerText = savingPercentage;
        //     } else {
        //       percentageEl.innerText = savingPercentage;
        //     }

        //     // update amount
        //     let amountEl = el.querySelector(".product-saving-amount");
        //     const amountSpan = amountEl.querySelector("span");
        //     if (amountSpan) {
        //       amountSpan.innerText = savingPrice;
        //     } else {
        //       amountEl.innerText = savingPrice;
        //     }
        //   });
        // }else if (customSavePrice.length > 0 && savingPrice == null){
        //   document.querySelector('.product-wrapper .product_review_block').removeChild('.product__price--savings')
        // }else if (customSavePrice.length == 0){
        //   let comp = document.createElement('div');
        //   comp.classList.add('custom-save-prices')
        //   let html = `<span class="product__price--savings">
        //         <span class="product-saving-percentage">${savingPercentage}%</span> Off - Save
        //         <span class="product-saving-amount">${savingPrice}</span>
        //       </span>
        //   </div>`;

        //   comp.innerHTML = savingPrice ? html : '';
        //   document.querySelector('.product-wrapper .product_review_block').appendChild(comp)
        // }
      }
    }

let isAdding = false;

// form.addEventListener('submit', function (event) {
//   event.preventDefault();
  
//   if (isAdding) return; // Prevent duplicate submissions
//   isAdding = true;
  
//   const formData = new FormData(form);
//   fetch('/cart/add.js', {
//     method: 'POST',
//     body: formData,
//   })
//   .then(response => response.json())
//   .then(data => {
//     console.log('Product added to cart:', data);
//     updateSubtotalPrice();
//     updateCartDrawer();
//   })
//   .catch(error => {
//     console.error('Error adding product to cart:', error);
//   })
//   .finally(() => {
//     isAdding = false; // Reset flag after completion
//   });
// });

    
// Attach event listener
// document.querySelectorAll('.form__selectors input[type="radio"]').forEach(input => { 
//   input.addEventListener('change', function () {
//     updateVariantDetails(this.value);
//   });
// });

document.querySelector('.shopify-product-form input[name="id"]').addEventListener('change',(e)=>{
  updateVariantDetails(e.target.value);
})

    // Re-run on option change
    document.querySelectorAll('.form__selectors input[type="radio"]').forEach(input => {
      input.addEventListener('change', function () {
        updateSnapColourImages();
      });
    });
  });
 // ============ END: Snap color image update ==============================

//  PDP Accordion Smooth Opne Js Start
function toggleAccordion(el) {
  const body = el.nextElementSibling;
  const icon = el.querySelector('.accordion-icon');

  const isOpen = body.classList.contains('open');

  // Close all others
  document.querySelectorAll('.custom-accordion-body').forEach(b => {
    if (b !== body) {
      b.classList.remove('open');
      b.style.maxHeight = null;
      b.style.display = 'none';
    }
  });

  document.querySelectorAll('.accordion-icon').forEach(i => {
    if (i !== icon) i.textContent = '▼';
  });

  if (isOpen) {
    // Close
    body.style.maxHeight = body.scrollHeight + 'px'; // set height before collapsing
    requestAnimationFrame(() => {
      body.style.maxHeight = '0';
    });
    icon.textContent = '▼';

    // After animation, hide completely
    setTimeout(() => {
      body.classList.remove('open');
      body.style.display = 'none';
    }, 400);
  } else {
    // Open
    body.classList.add('open');
    body.style.display = 'block';
    requestAnimationFrame(() => {
      body.style.maxHeight = body.scrollHeight + 'px';
    });
    icon.textContent = '▲';
  }
}
//  PDP Accordion Smooth Opne Js End


  document.addEventListener('DOMContentLoaded', () => {
    // const firstAccordionHeader = document.querySelector('.custom-accordion-header');
    // const firstAccordionBody = document.querySelector('.custom-accordion-body');
    // const firstIcon = firstAccordionHeader?.querySelector('.accordion-icon');
  
    // if (firstAccordionBody && firstAccordionHeader) {
    //   firstAccordionBody.classList.add('open');
    //   if (firstIcon) firstIcon.textContent = '▲';
    // }
    
  // Automatically open the first accordion on page load Start
    const firstBody = document.querySelector(".custom-accordion-body");
    const firstIcon = document.querySelector(".accordion-icon");
    if (firstBody) {
      firstBody.classList.add("open");
      firstBody.style.display = "block";
      firstBody.style.maxHeight = firstBody.scrollHeight + "px";
      if (firstIcon) firstIcon.textContent = "▲";
    }
// Automatically open the first accordion on page load End
  // =============== START: Upsell product code ===============
  // ========= START: Variant dropdown show/hide ========================
  // document.querySelectorAll(".variant-box-wrapper").forEach(box => {
  //     const dropdown = box.querySelector(".variant-dropdown-list");
  //     const colorBox = box.querySelector(".variant-color-box");

  //     if (dropdown && dropdown.querySelectorAll("li").length > 0) {   
  //       dropdown.querySelectorAll("li").forEach(item => {
  //         item.addEventListener("click", function (e) {
  //           e.stopPropagation();
  //           const parentElement = this.closest(".pair-with-item");
  //           parentElement.querySelector(".add-to-cart-btn").value = this.dataset.id;
  //           parentElement.querySelector(".pair-images img").src = this.dataset.image;
  //           const priceSpan = parentElement.querySelector(".pair-price span");
  //           if (priceSpan) {
  //             priceSpan.textContent = this.dataset.price;
  //           }
  //           else{
  //             parentElement.querySelector(".pair-price").textContent = this.dataset.price;
  //           }

  //           // colorBox.style.backgroundColor = this.style.backgroundColor;
  //           // dropdown.style.display = "none";
  //         });
  //       });
  //     }
  //   });
  document.querySelectorAll(".variant-box-wrapper").forEach(box => {
  const dropdown = box.querySelector(".variant-dropdown-list");
  const colorBox = box.querySelector(".variant-color-box");

  if (dropdown && dropdown.querySelectorAll("li").length > 0) {
    const items = dropdown.querySelectorAll("li");

    items.forEach(item => {
      item.addEventListener("click", function (e) {
        e.stopPropagation();
        const parentElement = this.closest(".pair-with-item");

        if (parentElement) {
          const addToCartBtn = parentElement.querySelector(".add-to-cart-btn");
          const pairImage = parentElement.querySelector(".pair-images img");
          const priceSpan = parentElement.querySelector(".pair-price span");
          const pairPrice = parentElement.querySelector(".pair-price");

          if (addToCartBtn) addToCartBtn.value = this.dataset.id;
          if (pairImage) pairImage.src = this.dataset.image;
          if (priceSpan) priceSpan.textContent = this.dataset.price;
          else if (pairPrice) pairPrice.textContent = this.dataset.price;
        }

        // Optional:
        // if (colorBox) colorBox.style.backgroundColor = this.style.backgroundColor;
        // dropdown.style.display = "none";
      });
    });
  }
});
  // ========= END: Variant dropdown show/hide

  // ============== START: Upsell ajax event
  document.querySelectorAll(".pair-title-with-varint .add-to-cart-btn").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
  
      const parent = this.closest(".pair-title-with-varint");
      const input = parent.querySelector(".button-with-variant .add-to-cart-btn");
      const upsell_id = input ? input.value : null;
  
      if (!upsell_id) return;
  
      const data = {
        quantity: 1,
        id: upsell_id,
      };
  
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((data) => {
          const cartDrawer = document.querySelector(".cart__drawer");
          if (cartDrawer) {
            document.dispatchEvent(
              new CustomEvent("theme:cart:init", { bubbles: true })
            );
  
            cartDrawer.dispatchEvent(
              new CustomEvent("theme:drawer:open", {
                detail: {
                  cart: data,
                  customParam: "customAddItemEvent",
                },
                bubbles: true,
              })
            );
          } else {
            window.location.href = "/cart";
          }
        })
        .catch((error) => {
          console.error("Error adding to cart:", error);
        });
      });
  });
  // ============== END: Upsell ajax event ====================================

  // ============== START: Upsell scrollbar code ==============================

    const upsellList = document.querySelector('.pair-with-wrapper .pair-with-grid');
    if (!upsellList) return;

    let isMouseDown = false;
    let startX = 0;
    let scrollLeft = 0;

    upsellList.style.cursor = 'grab';

    upsellList.addEventListener('mousedown', function (e) {
      isMouseDown = true;
      startX = e.pageX - upsellList.offsetLeft;
      scrollLeft = upsellList.scrollLeft;
      upsellList.style.cursor = 'grabbing';
    });

    upsellList.addEventListener('mousemove', function (e) {
      if (!isMouseDown) return;
      const x = e.pageX - upsellList.offsetLeft;
      const walk = (x - startX) * 3; // scroll speed multiplier
      upsellList.scrollLeft = scrollLeft - walk;
    });

    ['mouseup', 'mouseleave'].forEach(eventType => {
      upsellList.addEventListener(eventType, function () {
        isMouseDown = false;
        upsellList.style.cursor = 'grab';
      });
    });
  // ============== END: Upsell scrollbar code ========================================

  //**================ START  Helmet product page description read more Button ==================
  const descBtn = document.querySelector(".custom-desc-btn");
  if(descBtn){
    document.querySelector(".custom-desc-btn").addEventListener("click", function () {
      const targetHeader = document.querySelector(".description-tab .custom-accordion-header");
      const readMoreBtn = document.querySelector(".description-tab .accordion-btn");
      const accordionItem = document.querySelector(".custom-accordion-item.description-tab");

      if (targetHeader) {
        // Scroll smoothly to the accordion header
        const offsetTop = targetHeader.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
          top: offsetTop,
          behavior: "smooth",
        });

        // Open accordion if not already open
        const body = targetHeader.nextElementSibling;
        const icon = targetHeader.querySelector(".accordion-icon");

        if (!body.classList.contains("open")) {
          // Close all accordions first
          document.querySelectorAll(".custom-accordion-body").forEach((b) => {
            b.classList.remove("open");
            b.style.removeProperty('max-height');
            b.style.display = 'none';
          });

          document.querySelectorAll(".accordion-icon").forEach((i) => {
            i.textContent = "▼";
          });

          // Open the targeted accordion
          body.classList.add("open");
          body.style.display = 'block';
          body.style.maxHeight = body.scrollHeight + 'px';
          if (icon) icon.textContent = "▲";
        }

        // Trigger "Read More" button if accordion isn't already expanded
        if (readMoreBtn && !accordionItem.classList.contains("expanded")) {
          readMoreBtn.click();
        }
      }
    });
  }

  //**================ END  Helmet product page description read more Button ==================

  // ================ START measure pop up Js =================================

  
  const trigger = document.getElementById("how-to-measure-trigger");
  const popup = document.getElementById("measurePopup");

  if (trigger && popup) {
    const close = popup.querySelector(".close-popup");
    const overlay = popup.querySelector(".popup-overlay");

    trigger.addEventListener("click", function () {
      popup.style.display = "flex";
      document.body.classList.add("measure-popup-open"); // Disable scroll
    });

    [close, overlay].forEach(function (el) {
      if (el) {
        el.addEventListener("click", function () {
          popup.style.display = "none";
          document.body.classList.remove("measure-popup-open"); // Restore scroll
        });
      }
    });
  }

  // ================ END measure pop up Js =================================

  // ================ START: Add/Remove out-of-stock class event =================================
  const outOfStockCombinations = [];

  // Step 1: Collect out-of-stock combinations
  document.querySelectorAll(".selected_variant.out-of-stock").forEach(el => {
    const title = el.dataset.variantTitle;
    if (title) {
      const options = title.split(" / ");
      outOfStockCombinations.push(options);
    }
  });

  // Step 2: Add class to out-of-stock option values
  function markOutOfStockOptions() {
    // Get current selected option values
    const selectedOptions = [];
    document.querySelectorAll('.form__selectors [data-option-position]').forEach(selector => {
      const selected = selector.querySelector('input[type="radio"]:checked');
      selectedOptions.push(selected ? selected.value : null);
    });
    console.log("selectedOptionss: ",selectedOptions);
    // Loop over each option selector
    document.querySelectorAll('.form__selectors [data-option-position]').forEach((selector, index) => {
      const option_inputs = selector.querySelectorAll('input[type="radio"]');
      option_inputs.forEach(input => {
        const testSelection = [...selectedOptions];
        testSelection[index] = input.value;
        // console.log("testSelection: ",testSelection);
        // console.log("indexx: ",index);
        // console.log("testSelection[index]: ",testSelection[index]);
        // console.log("testSelection: ",testSelection);
        // console.log("outOfStockCombinations: ",outOfStockCombinations);
        // console.log("testSelection[index]: ",testSelection[index]);
        // Check if this combination is out of stock
        const isOutOfStock = outOfStockCombinations.some(outCombo => {
          return outCombo.every((val, i) => {
            console.log("Index:", i, " | Value in outCombo:", val, " | Value in testSelection:", testSelection[i]);
            return testSelection[i] === val;
          });
        });
        if (isOutOfStock) {
          input.parentElement.classList.add('out-of-stock'); // assuming label wraps input
        } else {
          input.parentElement.classList.remove('out-of-stock');
        }
      });
    });
  }

  // Step 3: Run on load
  markOutOfStockOptions();

  // Step 4: Re-run on option change
  document.querySelectorAll('.form__selectors input[type="radio"]').forEach(input => {
    input.addEventListener('change', function () {
      markOutOfStockOptions();
    });
  });

  // ================ END: Add/Remove out-of-stock class event =================================
    
   // ============ START Faq accordion Block Js ==============================

  var headers = document.querySelectorAll(".faq-tabs .accordion-header");
  headers.forEach(function (header) {
    header.addEventListener("click", function () {
      var accordion = this.parentElement;

      // Close all other accordions
      document.querySelectorAll(".faq-tabs .accordion").forEach(function (acc) {
        if (acc !== accordion) {
          acc.classList.remove("open");
        }
      });

      // Toggle current accordion
      accordion.classList.toggle("open");
    });
  });
   // ============ END Faq accordion Block Js ==============================

   const descriptionTab = document.querySelector(".custom-accordion-item.description-tab");
if (descriptionTab) {
  descriptionTab.classList.add("expanded");
  const readMoreBtn = descriptionTab.querySelector(".accordion-btn");
  if (readMoreBtn) {
    readMoreBtn.style.display = "none";
  }
}


    //  ====================== Start PDP show More Button  Js ==============================
    
    const showMoreButton = document.querySelector(".show-more-button");
if (showMoreButton) {
  let isExpanded = false;

  showMoreButton.addEventListener("click", function () {
    if (!isExpanded) {
      document.querySelectorAll(".media-item.hidden-image").forEach(el => {
        el.classList.remove("hidden-image");
        el.classList.add("was-hidden");
      });
      showMoreButton.textContent = "Show Less ";
      const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
      svg.setAttribute("width", "12");
      svg.setAttribute("height", "13");
      svg.setAttribute("viewBox", "0 0 12 13");
      svg.setAttribute("fill", "none");
      const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
      path.setAttribute("d", "M6 2.9L0 9.30005H12L6 2.9Z");
      path.setAttribute("fill", "#FCFAF7");
      svg.appendChild(path);
      showMoreButton.appendChild(svg);
    } else {
      document.querySelectorAll(".media-item.was-hidden").forEach(el => {
        el.classList.add("hidden-image");
        el.classList.remove("was-hidden");
      });
      document.querySelector(".product__media__wrapper.product_grid_img").scrollIntoView({ behavior: "smooth" });

      showMoreButton.textContent = "Show More ";
      const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
      svg.setAttribute("width", "12");
      svg.setAttribute("height", "13");
      svg.setAttribute("viewBox", "0 0 12 13");
      svg.setAttribute("fill", "none");
      const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
      path.setAttribute("d", "M6 10.1L0 3.69995H12L6 10.1Z");
      path.setAttribute("fill", "#FCFAF7");
      svg.appendChild(path);
      showMoreButton.appendChild(svg);
    }

    isExpanded = !isExpanded;
  });
}


    //  ====================== End PDP show More Button  Js ==============================
    
  
});
